import { ReceiptText } from 'lucide-react';
import { generatePath, Link } from 'react-router';

import paths from '@/lib/paths';
import cn from '@/lib/utils/cn';
import { toDateString } from '@/lib/utils/date';
import formatCurrency from '@/lib/utils/formatCurrency';

import type { Invoice } from '../../types';

type Props = {
  invoice: Invoice;
};

export default function InvoiceItem({ invoice }: Props) {
  return (
    <Link
      to={generatePath(paths.invoices.detail, { id: invoice.id })}
      className="shadow-card flex items-center justify-between rounded-lg border p-2"
    >
      <div className="flex flex-col">
        <div className="flex items-center gap-1 text-sm leading-tight">
          <ReceiptText className="size-3.5 shrink-0" />

          {invoice.description ?? '-'}
        </div>

        <div className="text-muted-foreground flex gap-2 text-xs">
          <span>{invoice.anva_invoice_nr}</span>

          <span>{toDateString(invoice.due_date ?? invoice.invoice_date)}</span>
        </div>
      </div>

      <div className="flex flex-col items-end text-sm">
        {invoice.outstanding_amount && (
          <div className="text-red-500">
            {formatCurrency(invoice.outstanding_amount)}
          </div>
        )}

        <div
          className={cn({
            ['text-muted-foreground text-sm']: invoice.outstanding_amount,
          })}
        >
          {formatCurrency(invoice.total_amount)}
        </div>
      </div>
    </Link>
  );
}
